module.exports = __webpack_public_path__ + "img/2021_09_dande_tokyotower_a4_fin_web.375016d5.png";